import { Data, Model, Utils } from "@singularsystems/neo-core";
import { injectable } from "inversify";
import UpdateTransactionCommand from "../../DataInterception/Transactions/Models/Commands/UpdateTransactionCommand";
import { AxiosPromise } from "axios";
import CommandResult from "../../Common/Models/CommandResult";
import { AppService, Types } from "../StaticData/StaticDataTypes";
import AuthorisableUpdateRequestSearchCriteria from "../AuthorisableUpdateRequests/Transactions/Models/Queries/AuthorisableUpdateRequestSearchCriteria";
import AuthorisableUpdateRequestBatchLookup from "../AuthorisableUpdateRequests/Transactions/Models/Lookups/AuthorisableUpdateRequestBatchLookup";
import DeclineRequestCommand from "../AuthorisableUpdateRequests/Transactions/Models/Commands/DeclineRequestCommand";
import DeclineBatchCommand from "../AuthorisableUpdateRequests/Transactions/Models/Commands/DeclineBatchCommand";
import ProcessBatchCommand from "../AuthorisableUpdateRequests/Transactions/Models/Commands/ProcessBatchCommand";
import UpdateCashTransactionCommand from "../../DataInterception/Transactions/Models/Commands/UpdateCashTransactionCommand";
export interface IAuthorisableUpdateRequestApiClient { 
  createAuthorisableUpdateTransactions(command: Model.PlainObject<UpdateTransactionCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
  getAuthorisableUpdateRequests(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<AuthorisableUpdateRequestSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<AuthorisableUpdateRequestBatchLookup>>>;
  declineRequest(command: Model.PlainObject<DeclineRequestCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
  declineBatch(command: Model.PlainObject<DeclineBatchCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
  processBatch(command: Model.PlainObject<ProcessBatchCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;  
}

@injectable()
export default class AuthorisableUpdateRequestApiClient extends Data.ApiClientBase implements IAuthorisableUpdateRequestApiClient {
  constructor(config = AppService.get(Types.Config)) {
    super(`${config.apiPath}/AuthorisableUpdateRequest`)
  }
  public createAuthorisableUpdateTransactions(command: Model.PlainObject<UpdateTransactionCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
    return this.axios.post(`${this.apiPath}/CreateAuthorisableUpdateTransactions`, command);
  }

  public createAuthorisableUpdateCashTransactions(command: Model.PlainObject<UpdateCashTransactionCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
    return this.axios.post(`${this.apiPath}/CreateAuthorisableUpdateCashTransactions`, command);
  }

  public getAuthorisableUpdateRequests(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<AuthorisableUpdateRequestSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<AuthorisableUpdateRequestBatchLookup>>> {
    return this.axios.get(`${this.apiPath}/GetAuthorisableUpdateTransactionsByStatus?${Utils.getQueryString(payload)}`);
  }

  public processBatch(command: Model.PlainObject<ProcessBatchCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
    return this.axios.post(`${this.apiPath}/ProcessBatch`, command);
  }

  public declineRequest(command: Model.PlainObject<DeclineRequestCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
    return this.axios.post(`${this.apiPath}/DeclineRequest`, command);
  }

  public declineBatch(command: Model.PlainObject<DeclineBatchCommand>): AxiosPromise<Model.PlainObject<CommandResult>>{
     return this.axios.post(`${this.apiPath}/DeclineBatch`, command);
  }
}